import CreateRubricAI from 'pages/CreateRubricAI';
import CreateRubricManual from 'pages/CreateRubricManual';
import qs from 'query-string';
import { useLocation } from 'react-router-dom';

const CreateRubricPage = ({ ...props }) => {
    const { search } = useLocation();
    const { path } = qs.parse(search);

    if (path === 'ai') return <CreateRubricAI {...props} />;
    if (path === 'manual') return <CreateRubricManual {...props} />;

    return null;
};

export default CreateRubricPage;
